// >>>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>
// src/index.js
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { StockComparisonProvider } from './contexts/StockComparisonContext';
import { WatchlistProvider } from './contexts/StockWatchlistContext';
import { AuthProvider } from 'react-oidc-context';

const cognitoAuthConfig = {
  authority: 'https://eu-west-2tofxpip5e.auth.eu-west-2.amazoncognito.com',
  client_id: 'les81m9p8roonusucosdoe4td',
  redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid email profile',
  loadUser: true,
  metadata: {
    issuer: 'https://cognito-idp.eu-west-2.amazonaws.com/eu-west-2_TofxPIp5e',
    authorization_endpoint: 'https://eu-west-2tofxpip5e.auth.eu-west-2.amazoncognito.com/oauth2/authorize',
    token_endpoint: 'https://eu-west-2tofxpip5e.auth.eu-west-2.amazoncognito.com/oauth2/token',
    userinfo_endpoint: 'https://eu-west-2tofxpip5e.auth.eu-west-2.amazoncognito.com/oauth2/userInfo',
    end_session_endpoint: 'https://eu-west-2tofxpip5e.auth.eu-west-2.amazoncognito.com/logout',
  },

  onSigninCallback: () => {
    const redirect = sessionStorage.getItem('postLoginRedirect') || '/';
    sessionStorage.removeItem('postLoginRedirect');

    // strip OIDC query params so the app doesn't render a route first
    window.history.replaceState({}, document.title, window.location.origin + '/');

    // jump straight to the intended page
    window.location.replace(redirect);
  },
};

// Detect OIDC redirect/callback so we don't render the app during processing
const qs = window.location.search;
const isAuthCallback =
  (qs.includes('code=') && qs.includes('state=')) || qs.includes('error=');

// react-snap runs in a headless browser and sets UA to exactly "ReactSnap"
const isReactSnap =
  typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

// During prerender, keep the provider in place, but make it as inert as possible
const prerenderAuthConfig = {
  ...cognitoAuthConfig,
  loadUser: false,
  automaticSilentRenew: false,
};

// Wrap all routing and contexts inside
function AppWithRouter() {
  return (
    <BrowserRouter>
      <StockComparisonProvider>
        <WatchlistProvider>
          <App />
        </WatchlistProvider>
      </StockComparisonProvider>
    </BrowserRouter>
  );
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root not found');
}

// Avoid hydration mismatches on auth callback URLs where you intentionally render nothing
if (isAuthCallback) {
  container.innerHTML = '';
}

const appTree = (
  <React.StrictMode>
    <AuthProvider {...(isReactSnap ? prerenderAuthConfig : cognitoAuthConfig)}>
      {isAuthCallback ? null : <AppWithRouter />}
    </AuthProvider>
  </React.StrictMode>
);

const hasPrerenderedMarkup =
  container.innerHTML && container.innerHTML.trim().length > 0;

if (hasPrerenderedMarkup && !isAuthCallback) {
  hydrateRoot(container, appTree);
} else {
  const root = createRoot(container);
  root.render(appTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// <<<<<<<<<<<<<<<<<<<<<<<< Code to add <<<<<<<<<<
